import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesOrderdetail {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        if (webcontext.Client.PageName == "Orderdetail") {
            webcontext['isOrderdetail'] = true;
            if (webcontext.ConfigName == "TBJingZhiYouJiXML" && webcontext.OpType.toLowerCase() == "query") {
                const id = JSON.parse(webcontext.RequestBody).a_ID;
                webcontext.RequestBody = JSON.stringify({ 'a_FK_OrderMaster_ID': id });
                console.log(webcontext);
            }
        }
        return webcontext;
    }
}